import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Billing from "src/features/payments/billing/Billing";
const BillingPage = () => {
    return (_jsx(_Fragment, { children: _jsx(Billing, {}) }));
};
export default BillingPage;
